/*
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-06-13 11:26:56
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-06-19 16:38:22
 * @FilePath: \frontend\src\api\ArticleContent\ArticleContent.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as api from "../api";
import axios from "axios";
import { URLS } from "../../../public/urlConfig";
// import router from '../routerManuaConfig'
import Vue from "vue";
let base = api.BaseApiUrl;

if (base == undefined) {
  base =
    process.env.NODE_ENV == "production"
      ? window.apiAdress
      : "http://localhost:9291";
}
///指南管理
export const getArticleListPage = (params) => {
  return axios.get(`${base}/api/Articlecontent/get`, { params: params });
};

export const addArticle = (params) => {
  return axios.post(`${base}/api/Articlecontent/AddArticle`, params);
};

export const editArticle = (params) => {
  return axios.post(`${base}/api/Articlecontent/PutArticle`, params);
};
export const DeleteArticle = (params) => {
  return axios.get(`${base}/api/Articlecontent/DeleteArticle`, {
    params: params,
  });
};
export const QueryBlogList = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params });
};
export const QueryBlogDetail = (params) => {
  return axios.get(`${base}/api/Blog/GetBlogById`, { params: params });
};
export const QueryBlogDetailByCategory = (params) => {
  return axios.get(`${base}/api/Blog/GetBlogByCategory`, { params: params });
};
export const UpdateBlogDetail = (data) => {
  return axios.put(`${base}/api/Blog/Update`, data);
};
export const AddBlogDetail = (data) => {
  return axios.post(`${base}/api/Blog`, data);
};
export const DelBlogDetail = (data) => {
  return axios.delete(`${base}/api/Blog/Delete`, { params: data });
};

export const BlogGetUpdateSticky = (params) => {
  return axios.get(`${base}/api/Blog/GetUpdateSticky`, { params: params });
};
